/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

/*
A little info for this js file:

As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
	As mentioned below, most code added to this file should be included within the "on load" function.

For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
	including any relevant details regarding what the code overrides, etc.
*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		* The click functionality involves three different actions,
		* depending on conditions the various clicks provide.
		* 
		* NOTE: This script assumes there is one search form on the page.
		*/
		var searchOpen = document.querySelector('.search-form__button--open');
		var searchClose = document.querySelector('.search-form__button--close');
		var searchForm = document.getElementById( 'search-form' );
		var formContainer = document.querySelector( '.search-form__container' );

		searchOpen.addEventListener( 'click', function() {
			searchForm.classList.add( 'search-form--active' );
			var input = document.getElementById('search-input');
			input.focus();
			input.select();

			// Hide the search bar after click out of it
			document.getElementById( 'content' ).addEventListener( 'click', function() {
				if ( searchForm.classList.contains( 'search-form--active' ) ) {
					searchForm.classList.remove( 'search-form--active' );
					formContainer.removeChild( document.querySelector( '.search_close' ) );
				}
			});
		});

		searchClose.addEventListener( 'click', function() {
			searchForm.classList.remove( 'search-form--active' );
		});


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];
			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}

		// This won't be on the home page, so doing this quick and dirty for now
		if (window.jQuery) {
			$('.applications__nav-button').on('click', function() {
				var parent = $(this).closest('.applications__section');
				$(this).siblings('.active').removeClass('active');
				$(this).addClass('active');
				var index = $(this).index();
				parent.find('.applications__description.active').removeClass('active');
				parent.find('.applications__description').eq(index).addClass('active');
				parent.find('.applications__image.active').removeClass('active');
				parent.find('.applications__image').eq(index).addClass('active');
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			if ( link_element.classList.contains( 'goog-te-menu-value' ) ) return; 
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {
			
			
			// causing google translate to error out 2020-09-25



			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}


		/**
		 * Animated Form Labels
		 */
		var labelFields = document.querySelectorAll('.animate-label');

		if ( labelFields ) {
			for ( var i = 0; labelFields.length > i; i++ ) {
				var field = labelFields[i];
				var input = field.querySelector('input');
				
				input.addEventListener('focus', function() {
					this.parentElement.parentElement.classList.add('active');
				});

				input.addEventListener('blur', function() {
					var $this = this;
					
					setTimeout(function() {
						if ( $this.value == '' ) {
							$this.parentElement.parentElement.classList.remove('active');
						}
					}, 100);
				});
			}
		}


		/**
		 * Captures Google Analytics Client ID and inputs into hidden form field
		 */
		var g_id = document.querySelector('.g-id input' );

		function fillClientId() {
			// Capture Client ID
			var clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
			// Populate hidden form field with Client ID
			g_id.value = clientId;
		}

		// On pages with client ID form field and analytics is loaded, populate
		if ( g_id && Object.keys( window.google_tag_manager || [] ).filter( e => { return e.substring(0,2) == 'G-' } ).length > 0 ) {
			// Give GTM time to load
			setTimeout(function() {
				fillClientId();
			}, 5000);
		}

		/**
		 * Form completion event for custom event trigger/goal completion
		 * 
		 * The point of this method is to eliminate false conversions in Analytics
		 * due to users refreshing the /thank-you/ page. This will now set a cookie after a form 
		 * submit event and get the form's id to pass into analytics. The analytics event for a goal
		 * conversion is then generated if there a form completion cookie set, and the url is that
		 * of a thank-you page. Each form will have a unique conversion event in Analytics based on
		 * the formID that gets passed as the event label.
		 * 
		 * There is the assumption that all forms on the site are a Gravity Form, and that
		 * they re-direct to a /thank-you page of some kind on completion. 
		 */
		 var form = document.querySelector('.gform_wrapper form');

		 if (form) {
			 form.addEventListener('submit', function () {
				 setCookie( 'form-completion', 'form-completion-value', 1 );
				 setCookie( 'form-id', form.getAttribute( 'id' ), 1 );
			 });
		 }
 
		 var formCompleted = readCookie( 'form-completion' );
		 var formId = readCookie( 'form-id' );
		 var url = window.location.href.indexOf( 'thank' ) >= 0; // Not exactly thank-you because the 
																 // page titles/urls vary, but all contain 'thank'
 
		 if ( formCompleted == 'form-completion-value' && url ) {			 
			 // Create analytics event
			 window.dataLayer = window.dataLayer || [];
			 window.dataLayer.push({
				 event: "formSubmission",
				 formID: formId
			 });
 
			 // Remove cookies so event cannot be fired again on /thank-you page refresh
			 eraseCookie( 'form-completion');
			 eraseCookie( 'form-id');
		 }


		 /**
		  * Open a subscription modal when links with the "download-brochure" class are clicked
		  */
		var downloadBrochure = document.querySelector('.download-brochure');

		if ( downloadBrochure ) {
			var classModal = document.getElementById('brochure-class-modal');
			var toggleBrochureClose = document.querySelector('#brochure-class-modal .modal__close_button');

			function toggleBrochureModal() {
				classModal.classList.toggle('active');
			}

			downloadBrochure.addEventListener('click', function(e) {
				// Prevent the link from working
				e.preventDefault();
				// Capture the link destination
				var url = this.href;
				// Put this link in the hidden form field
				document.querySelector('input.gform_hidden').value = url;
    
				var brochureGateForm = document.querySelector('#brochure-class-modal form.brochure-gate');
				/**
				 * Replaces form with confirmation message when submitted
				 */
				brochureGateForm.addEventListener('submit', function() {
					var confirmMsg = document.createElement("p");
					confirmMsg.innerHTML = '<p>Thank you for your interest! Your download should begin automatically.</p>';
					setTimeout(function() {            
						brochureGateForm.parentElement.style.display = 'none';
						brochureGateForm.parentElement.parentElement.append(confirmMsg);
					}, 50);
				});

				// Open the modal
				toggleBrochureModal();
			});
	
			toggleBrochureClose.addEventListener( 'click', function() {
				toggleBrochureModal();
			});
	
			// Close modal on escape
			document.addEventListener( 'keyup', function(e) {
				if ( e.key === "Escape" && classModal.classList.contains('active') ) {
					toggleBrochureModal()
				}
			});
	
			// // Close modal on click away
			window.addEventListener( 'click', function(e) {
				if ( e.target == document.getElementById('content') && classModal.classList.contains('active') ) {
					toggleBrochureModal();
				}
			});
		}
	}); // End of load function

	/**
	 * Js for detecting a modals id and opening that modal
	 */
	var modalToggles = document.querySelectorAll( '.modal__open' );
	for ( var i = 0; modalToggles.length > i; i++ ) {
		modalToggles[i].addEventListener( 'click', function(e) {
			var relativeModal = this.getAttribute( 'href' );
			e.preventDefault();
			document.getElementById( relativeModal ).classList.remove('hide');
		});
	}
    
    var modalCloseBtns = document.querySelectorAll( '.modal__close_button' );
	for ( var i = 0; modalCloseBtns.length > i; i++ ) {
		modalCloseBtns[i].addEventListener( 'click', function(e) {
			e.preventDefault();
			this.parentElement.parentElement.classList.add('hide');
		});
	}


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
